import React from 'react';
import { Icon } from '../ui/Icon.jsx';
import { catalogueUrl } from '../../lib/utils.js';
import { isSuperAdminSession } from '../../lib/session.js';

const FULL_STYLE = {
  padding: '9px 18px', borderRadius: 8, background: 'var(--sedra-forest)',
  color: '#fff', fontSize: 13, fontWeight: 700, whiteSpace: 'nowrap',
  display: 'inline-flex', alignItems: 'center', gap: 6, textDecoration: 'none',
};

const COMPACT_STYLE = {
  padding: '5px 10px', borderRadius: 6, background: 'var(--sedra-sage-wash)',
  color: 'var(--sedra-forest-soft)', fontSize: 11, fontWeight: 700, whiteSpace: 'nowrap',
  display: 'inline-flex', alignItems: 'center', gap: 4, textDecoration: 'none',
};

// ─── VIEW AS CUSTOMER ─────────────────────────────────────────────────────────
// The single impersonation entry point. Owns the URL shape (?admin=1 — must
// match CatalogueView's detector), icon, and bilingual copy so the Token
// Manager and Applications screens can't drift apart. `compact` renders the
// small pill used on token rows.
//
// Hidden for anyone but a super admin — the same rule CatalogueView enforces,
// so lower-privileged staff never see a button that would land them on a
// customer catalogue with no banner.
export function ViewAsCustomerLink({ token, lang, compact = false }) {
  const ar = lang === 'ar';
  if (!token || !isSuperAdminSession()) return null;
  return (
    <a href={catalogueUrl(token, { admin: true })} target="_blank" rel="noreferrer"
      title={ar
        ? 'افتح كتالوج هذا العميل بكل مزاياه مع إمكانية العودة للوحة التحكم'
        : "Open this customer's catalogue with all their features; banner lets you exit back to admin"}
      style={compact ? COMPACT_STYLE : FULL_STYLE}>
      <Icon name="Eye" size={compact ? 11 : 13} /> {ar ? 'عرض كالعميل' : 'View as customer'}
    </a>
  );
}
